import {
  FormControl,
  ListItemText,
  MenuItem,
  Autocomplete,
  TextField,
} from "@mui/material";
import { SxProps } from "@mui/system";
import { ChevronDown } from "lucide-react";
import Radio from "./Radio";
export type Option = {
  label: string;
  value: string;
};

type Props = {
  options: Option[];
  onChange: (s: Option) => void;
  value: Option | null;
  sx?: SxProps;
  disabled?: boolean;
  placeholder: string;
  disableClearable?: boolean;
};

export default ({
  options,
  onChange,
  value,
  placeholder,
  disabled = false,
  disableClearable = false,
  sx,
}: Props) => {
  const handleChange = (event: any, newValue: Option | null) => {
    if (newValue) {
      onChange(newValue);
    }
  };

  return (
    <FormControl
      sx={{
        cursor: "pointer",
        "& .MuiInputLabel-root": {
          marginTop: "-4px",
        },
        ...sx,
      }}
    >
      <Autocomplete<Option>
        popupIcon={<ChevronDown />}
        disabled={disabled}
        value={value}
        onChange={handleChange}
        options={options}
        getOptionLabel={(option) => (option.value ? option.label : placeholder)}
        renderOption={(props, option) => (
          <MenuItem
            {...props}
            key={option.value}
            disableRipple={true}
            disableTouchRipple={true}
          >
            <Radio size="small" checked={value?.value === option.value} />
            <ListItemText primary={option.label} sx={{ fontWeight: "700" }} />
          </MenuItem>
        )}
        renderInput={(params) => (
          <TextField
            placeholder={placeholder}
            {...params}
            inputProps={{
              ...params.inputProps,
            }}
            InputLabelProps={{
              shrink: true,
              sx: { display: "none" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                minHeight: "48px",
                height: "48px",
                borderRadius: "100px",
                padding: "0px 36px 0px 20px",
                border: "2px solid #EAEBEC !important",
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  border: "none",
                },
                "&.Mui-focused fieldset": {
                  border: "none",
                },
                cursor: "pointer",
                "& .MuiInputBase-input": {
                  marginTop: "0px",
                  cursor: "pointer",
                  userSelect: "none",
                },
              },
            }}
            onClick={() => {
              if (!disabled) {
                const input = document.querySelector("input");
                input?.click();
              }
            }}
          />
        )}
        slotProps={{
          clearIndicator: {
            sx: { display: disableClearable ? "none" : undefined },
          },
        }}
        componentsProps={{
          popper: {
            sx: {
              "& .MuiAutocomplete-paper": {
                marginTop: "8px",
                minWidth: "220px",
                width: "max-content",
                "& .MuiMenuItem-root": {
                  "&:hover": { backgroundColor: "transparent" },
                  "&.Mui-selected": { backgroundColor: "transparent" },
                  "&.Mui-selected:hover": { backgroundColor: "transparent" },
                  "&.Mui-selected, &:focus": { backgroundColor: "transparent" },
                },
              },
            },
          },
        }}
      />
    </FormControl>
  );
};
